import type { RouteObject } from 'react-router-dom';

export const zakatRoutes: RouteObject[] = [
  { path: 'zakat', lazy: () => import('./ZakatSimplePage').then((m) => ({ Component: m.ZakatSimplePage })) },
  { path: 'zakat/detaille', lazy: () => import('./ZakatCalculatorPage').then((m) => ({ Component: m.ZakatCalculatorPage })) },
  { path: 'zakat/payer', lazy: () => import('./ZakatPayPage').then((m) => ({ Component: m.ZakatPayPage })) },
  { path: 'zakat/revenus', lazy: () => import('./ZakatIncomesPage').then((m) => ({ Component: m.ZakatIncomesPage })) },
  { path: 'zakat/historique', lazy: () => import('./ZakatHistoryPage').then((m) => ({ Component: m.ZakatHistoryPage })) },
];
